var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.6875 8.10706H26.8914V24.39H4.6875V8.10706ZM7.62031 9.58732L15.7895 15.8114L23.9586 9.58732H7.62031ZM25.4112 10.3416L15.7895 17.6724L6.16776 10.3416V22.9097H25.4112V10.3416Z","fill":"#2E2B26"}));
}

Mail.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
